import appConfig from '@/features/app/constants/app-config';
import staleQueryIfNotError from '@/features/app/functions/staleQueryIfNotError';
import useAdminSettingsQuery from '@/features/app/queries/useAdminSettingsQuery';
import { Pages } from '@/features/custom-pages/types/pages-response';
import useUnauthenticatedAxios from '@/shared/hooks/useAuthenticatedAxios';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import useFeatureFlags from '@/features/feature-flags/hooks/useFeatureFlags';

export default function usePagesQuery() {
  const { i18n, t } = useTranslation();
  const { data: adminSettings } = useAdminSettingsQuery();
  const featureFlags = useFeatureFlags();
  const axios = useUnauthenticatedAxios();

  return useQuery<Pages>({
    queryKey: ['pageContents', i18n.language, adminSettings],
    async queryFn() {
      return axios
        .get(`/api/v1/page-contents`, {
          params: {
            'populate[pageCategories][carousel]': 1,
            'populate[pageCategories][pageContent]': 1,
          },
        })
        .then((res) => res.data)
        .then((res) => {
          return {
            ...res,
            aboutUs: {
              title: 'About Us',
              ...res.aboutUs[0],
            },
            privacyPolicy: {
              title: t('page.privacyPolicy.title'),
              content:
                '<p>Aliquip nisi tempor amet occaecat consequat consequat exercitation ea. Qui consequat nisi duis velit non nisi duis ut esse. Ipsum incididunt veniam fugiat nostrud proident consequat voluptate consequat. Amet duis aute in cillum ipsum est. Lorem fugiat dolor ad tempor officia ea officia mollit consequat.</p><p>Ut est minim sit laboris sint reprehenderit occaecat tempor non commodo ipsum excepteur pariatur. Mollit elit excepteur enim qui consectetur aute ad cillum elit est ipsum. Proident ipsum aliquip non Lorem labore exercitation laborum nostrud commodo. Voluptate nulla tempor officia laborum anim veniam dolore magna nisi labore ad elit ex laboris velit. Veniam do laboris aliquip duis dolor qui amet esse. Ea pariatur consequat dolore consectetur duis consectetur ea mollit culpa cillum aliqua cupidatat dolore minim cillum.</p>',
            },
            contactUs: res.contactUs[0],
          };
        });
    },
    enabled: adminSettings && featureFlags.page.misc.enableCustomPage === true,
    ...staleQueryIfNotError(appConfig.defaultLongDataStaleTime),
  });
}
